var map = {
	"./01.jpg": 4489,
	"./02.jpg": 8350,
	"./03.jpg": 4811,
	"./04.jpg": 1976,
	"./05.jpg": 9237,
	"./06.jpg": 1898,
	"./07.jpg": 903,
	"./08.jpg": 2900,
	"./09.jpg": 1425,
	"./10.jpg": 9819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9204;